import axios from 'axios';

// Support both REACT_APP_API_URL (new) and REACT_APP_BACKEND_URL (legacy)
const BACKEND_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/client`;

// Get client token from localStorage
const getClientToken = () => {
  return localStorage.getItem('client_token');
};

// Set auth header
const getAuthHeaders = (token = null) => {
  const authToken = token || getClientToken();
  return {
    'Authorization': `Bearer ${authToken}`,
    'Content-Type': 'application/json'
  };
};

// Client Authentication
export const clientRegister = async (userData) => {
  const response = await axios.post(`${API}/register`, userData);
  if (response.data.access_token) {
    localStorage.setItem('client_token', response.data.access_token);
    localStorage.setItem('client_data', JSON.stringify({
      client_id: response.data.client_id,
      name: response.data.name,
      email: response.data.email
    }));
  }
  return response.data;
};

export const clientLogin = async (email, password) => {
  const response = await axios.post(`${API}/login`, { email, password });
  if (response.data.access_token) {
    localStorage.setItem('client_token', response.data.access_token);
    localStorage.setItem('client_data', JSON.stringify({
      client_id: response.data.client_id,
      name: response.data.name,
      email: response.data.email
    }));
  }
  return response.data;
};

export const clientLogout = () => {
  localStorage.removeItem('client_token');
  localStorage.removeItem('client_data');
};

export const isClientAuthenticated = () => {
  return !!getClientToken();
};

export const getClientData = () => {
  const data = localStorage.getItem('client_data');
  return data ? JSON.parse(data) : null;
};

// Verify token
export const verifyClientToken = async () => {
  try {
    const response = await axios.get(`${API}/verify`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    clientLogout();
    throw error;
  }
};

// Client Profile
export const getClientProfile = async () => {
  const response = await axios.get(`${API}/profile`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateClientProfile = async (updateData) => {
  const response = await axios.put(`${API}/profile`, updateData, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Client Orders
export const getClientOrders = async () => {
  const response = await axios.get(`${API}/orders`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getClientOrderDetails = async (orderId) => {
  const response = await axios.get(`${API}/orders/${orderId}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};
